
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/compliance-api",
      function () {
        return require("private-next-pages/products/compliance-api.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/compliance-api"])
      });
    }
  